import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { BackIcon } from 'assets/materialIcons/materialIcons';
import { Link } from 'react-router-dom';

const GoBackButton = (props) => {
    const {
        translate,
        url,
    } = props;

    const style = {
        textDecoration: 'none',
        display: 'inline-flex',
    };

    return (
        <Link to={ url } style={ style }>
            <ActionButton
                icon={ <BackIcon color={ theme.palette.primary1Color } /> }
                title={ translate('actions.goBack') }
            />
        </Link>
    );
};

GoBackButton.propTypes = {
    translate: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
};

export default translate(GoBackButton);



// WEBPACK FOOTER //
// ./src/components/button/GoBackButton.js